import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import i18n from "./i18n/i18n";
import "boxicons";
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/700.css";

import * as filters from "./plugins/filters.js";

Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key]); //插入過濾器名和對應方法
});

//  event bus
Vue.prototype.$bus = new Vue();
Vue.prototype.$createDownloadLink = function (link, fileName) {
  let downloadLink = document.createElement("a");
  downloadLink.target = "_blank";
  downloadLink.rel = "noreferrer noopener";
  downloadLink.style.display = "none";
  if (fileName) {
    downloadLink.download = fileName;
  }

  if (/^(https?|blob):/.test(link)) {
    const encode = encodeURI(link);
    downloadLink.href = encode;
    downloadLink.click();
  } else {
    console.error("Invalid URL");
  }
};


// Element UI
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "./assets/scss/_element-variables.scss"; // 修改 ElementUI 預設變數
Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value),
});

// https://github.com/theomessin/vue-chat-scroll
import VueChatScroll from "vue-chat-scroll";
Vue.use(VueChatScroll);

import VueNativeNotification from "vue-native-notification";
Vue.use(VueNativeNotification, {
  // Automatic permission request before
  // showing notification (default: true)
  requestOnNotify: true,
});

// global Components
import SubTitle from "./components/layout/subtitle.vue";
import Page from "./components/global/pagination.vue";
import NuiDialog from "./components/global/nui_dialog.vue";
Vue.component("Page", Page);
Vue.component("SubTitle", SubTitle);
Vue.component("NuiDialog", NuiDialog);

new Vue({
  i18n,
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
